import { configureStore, Action } from '@reduxjs/toolkit';
import { ThunkAction } from "redux-thunk";
import rootReducer from './slices'

function configureAppStore(preloadedState ?: any) {
  const store = configureStore({
    reducer: rootReducer,
  })

  return store
}


export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppThunk = ThunkAction<void, RootState, unknown, Action>
export const store = configureAppStore();
